<section class="container weightage-detail-popup" [ngClass]="data?.classes">
	<div>
		<div class="close-icon cursor-pointer" (click)="dialogRef.close()">
			<mat-icon matRipple>close</mat-icon>
		</div>
	</div>
	<div class="weightage-detail-container" fxLayout="column" fxLayoutAlign="start stretch"
		fxLayoutAlign.xs="center stretch" fxLayoutGap="36px">
		<div class="weightage-detail-header" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
			<div class="title">{{locale.translate('skill_levels')}}</div>
		</div>
		<div class="weightage-detail-content"  fxLayout="column" fxLayoutAlign="start stretch">
			<div fxLayout="row" fxLayoutAlign="start stretch">
				<div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="0 1 510px" fxFlex.xs="100" fxLayoutGap="20px">
					<div class="weightage-detail-body">
						<ng-container *ngIf="data?.helpData?.length">
							<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="24px">
								<ng-container *ngFor="let help of data?.helpData">
									<ng-container *ngIf="help?.key !== null">
										<div class="items" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="14px">
											<div class="item-title">
												{{help?.value}}
											</div>
											<ng-container *ngIf="help?.description">
												<div class="item-detail" [innerHtml]="help?.description | safeDom"></div>
											</ng-container>
										</div>
									</ng-container>
								</ng-container>
							</div>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
